var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col justify-center items-center flex-none w-auto px-3 mb-0 ds-text-xs font-medium leading-tight border border-transparent border-solid rounded-14px",staticStyle:{"height":"28px"}},[_c('h2',{staticClass:"block my-auto ds-text-xs"},[_vm._v(_vm._s(_vm.genderPossessiveForm)+" "+_vm._s(_vm.sport))])])
}
var staticRenderFns = []

export { render, staticRenderFns }